import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import { label } from '../../styles/elements/label.js';
import { label3 } from '../../styles/typography/label3.js';

function Label(_ref) {
  var htmlFor = _ref.htmlFor,
      tabIndex = _ref.tabIndex,
      children = _ref.children,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ["htmlFor", "tabIndex", "children", "theme"]);

  var styleObject = useMemo(function () {
    return merge.all([label, label3, {
      textTransform: 'none',
      marginBottom: 0
    }, theme]);
  }, [theme]);
  return jsx("label", _extends({
    htmlFor: htmlFor,
    tabIndex: tabIndex,
    css: styleObject
  }, otherProps), children);
}
Label.defaultProps = {
  tabIndex: '-1',
  theme: {}
};

export default Label;
